"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSceneObjectTransform = void 0;
var createSceneObjectTransform = function (object) {
    var translate = "translate(".concat(object.frame.x, ", ").concat(object.frame.y, ")");
    var cx = object.frame.width / 2;
    var cy = object.frame.height / 2;
    var rotate = "rotate(".concat(object.frame.rotation, ", ").concat(cx, ", ").concat(cy, ")");
    return "".concat(translate, " ").concat(rotate);
};
exports.createSceneObjectTransform = createSceneObjectTransform;
